export default {
    // medium / small / mini
    size: {type: String, default: 'small'},

    // 是否禁用
    disabled: {type: Boolean, default: false},

    // 值
    value: {type: Array, default: () => []},

    // 输入类型 img / link / text
    type: {type: String, default: "text"},

    // 描述
    placeholder: {type: String, default: ""},
    target: {type: String, default: ""},

    // 最大数量限制
    limit: {type: [String, Number]},

    // 是否单个输入框
    alone: {
        type: Boolean,
        default: false
    }
}
